<script setup lang="ts" generic="T extends { value: string, label: string }">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

withDefaults(defineProps<{
  title: string
  icon: IconDefinition
  options: T[]
  resetAriaLabel: string
  backLabel?: string
}>(), {
  backLabel: 'Filter',
})

const emit = defineEmits<{ back: [] }>()
const selected = defineModel<T[]>({ required: true })

const listRef = useTemplateRef<{ reset: () => void }>('listRef')
</script>

<template>
  <div class="flex flex-col gap-m flex-1 min-h-0">
    <div class="flex w-full justify-between px-s">
      <DrawerBackButton @click="emit('back')">
        {{ backLabel }}
      </DrawerBackButton>
      <button v-if="selected.length > 0" class="text-small font-bold animate-fade" :aria-label="resetAriaLabel" @click="listRef?.reset()">
        Nullstill
      </button>
    </div>
    <DrawerFilterList ref="listRef" v-model="selected" :title="title" :icon="icon" :options="options" />
  </div>
</template>
